module.exports = __webpack_public_path__ + "img/specials-multislider-6040--toyota.46acf27b.jpeg";